'use strict';

const hostname = 'https://www.bayareamarketreports.com';

export default hostname;



// WEBPACK FOOTER //
// ./src/common/env/constants.js